export const DASHBOARD_DATA_REQUEST = 'DASHBOARD_DATA_REQUEST'
export const DASHBOARD_DATA_RECEIVE = 'DASHBOARD_DATA_RECEIVE'

export const DASHBOARD_PLANS_REQUEST = 'DASHBOARD_PLANS_REQUEST'
export const DASHBOARD_PLANS_RECEIVE = 'DASHBOARD_PLANS_RECEIVE'

export const DASHBOARD_PACKAGES_RECIEVE = 'DASHBOARD_PACKAGES_RECIEVE';
export const DASHBOARD_PACKAGES_REQUEST = 'DASHBOARD_PACKAGES_REQUEST';